import type { FC } from 'react';

import { EyeOff as Component } from '@untitledui-pro/icons/solid/EyeOff';

import { BaseIcon, type IconProps } from '../../base-icon/base-icon.tsx';

export type EyeOffProps = IconProps;

export const EyeOff: FC<EyeOffProps> = (props) => <BaseIcon {...props} Component={Component} />;
